<template>
  <div class="page-header">

    <img
      v-if="image"
      class="header-image"
      :src="image"
      :alt="title"
    />

    <div class="header-text">
      <h2>{{ title }}</h2>
      <div v-if="subtitle" class="subtitle">{{ subtitle }}</div>
      <slot name="extra"></slot>
    </div>

  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    image: { type: String, default: '' }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-bottom: 1.4rem;
}

.header-image {
  width: 140px;
  height: 140px;
  border-radius: 8px;
  object-fit: cover;
}

.header-text h2 {
  margin: 0;
  font-size: 1.8rem;
}

.subtitle {
  opacity: 0.8;
  margin-top: 0.25rem;
}
</style>
